/**
 * This program is free software; you can redistribute it and/or
 * modify it under the terms of the GNU General Public License
 * as published by the Free Software Foundation; under version 2
 * of the License (non-upgradable).
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License
 * along with this program; if not, write to the Free Software
 * Foundation, Inc., 51 Franklin Street, Fifth Floor, Boston, MA  02110-1301, USA.
 *
 * Copyright (c) 2025 (original work) Open Assessment Technologies SA
 */

import pageController from '@/core/page/page';
import RetryReset from '@/component/retryReset/RetryReset.svelte';
import { retryingAcs } from '@/store/retryingAcs';
import { get } from 'svelte/store';
import { routes } from '@/core/utils/consts';
export default () =>
    // eslint-disable-next-line implicit-arrow-linebreak
    pageController({
        name: 'retryReset',
        /**
         * Checks if retryingAcs store contains any acs,
         * or redirects to home page if that is not the case
         */
        start() {
            if (Object.keys(get(retryingAcs)).length > 0) {
                this.component = new RetryReset({
                    target: this.container
                });
            } else {
                this.router.redirect(routes.home);
            }
        }
    });
